<mat-sidenav-container
  class="mainWrapper blue_theme  light-theme"
  autosize
  autoFocus
  dir="ltr"
>
  

<mat-sidenav
#leftsidenav
[mode]="isOver ? 'over' : 'side'"
[opened]="!isOver"
class="sidebarNav"
[disableClose]="true"
>
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  
  <mat-sidenav-content class="contentWrapper">
   

    <app-header
      [showToggle]="!isOver"
      (toggleCollapsed)="toggleCollapsed()"
      (toggleMobileNav)="sidenav.toggle()"
    ></app-header>

    <main class="pageWrapper">
   
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
